import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9788b8d2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuNav: require('/opt/build/repo/components/menu/MenuNav.vue').default,FeaturedBanner: require('/opt/build/repo/components/menu/FeaturedBanner.vue').default,MenuCategories: require('/opt/build/repo/components/menu/MenuCategories.vue').default})
